<template>
  <div class="wy-interactions-metrics-page" v-loading="loading" element-loading-text="Loading...">
    <div>
      <div class="stats-header">
        <span>
          <div class="wy-page-title-small">{{$t(currentPageInfo.subtitle)}}</div>
          <div class="wy-page-title">{{$t(currentPageInfo.title)}}
            <!-- <wy-page-tooltip /> -->
          </div>
        </span>
      </div>
      <div v-if="hasData" class="stats-summary-zoom-in-on" v-show="!loading&&($refs.metricsChart&&$refs.metricsChart.chartRendered)">
        <wy-interactions-metrics-zoom-in-on ref="metricsChart" :data="zoomInData"/>
      </div>
      <no-data-page v-else> </no-data-page>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapGetters, mapActions } from 'vuex';
import WyInteractionsMetricsZoomInOn from './wy-interactions-metrics-zoom-in-on';
// import wyPageTooltip from '../../widgets/wy-page-tooltip.vue';
import noDataPage from '../../../views/PageNoDataWithAvailableDateRange';

export default Vue.extend({
  name: 'wy-interactions-metrics-page',
  components: {
    'wy-interactions-metrics-zoom-in-on': WyInteractionsMetricsZoomInOn,
    // 'wy-page-tooltip': wyPageTooltip,
    'no-data-page': noDataPage
  },

  data() {
    return {
      hasData: true,
      loading: false,
      zoomInData: null,
      initDate: null
    }
  },

  computed: {
    ...mapGetters(['dataModel', 'transfersVisible', 'containmentVisible', 'config', 'currentPageInfo','isLoggedIn']),
  },

  methods: {
    ...mapActions(['fetchMetrics']),

    async handleFilterChange() {
      if((!this.loading && this.dataModel.dateEnd) || this.dataModel.dateEnd) {
        this.loading = true;

        let res = await this.fetchMetrics();
        if(res.status == 200) {
          const xnumber = this.$store.getters.xnumber;
          this.zoomInData = res.data;
          this.zoomInData.totalVolumeDMValue = (this.zoomInData.totalVolume!=null ? this.zoomInData.totalVolume * xnumber : this.zoomInData.totalVolume);
          this.zoomInData.compareVolumeDMValue = (this.zoomInData.compareVolume!=null ? this.zoomInData.compareVolume * xnumber : this.zoomInData.compareVolume);
          this.zoomInData.volumeDMValueMedian = (this.zoomInData.volumeMedian!=null ? this.zoomInData.volumeMedian * xnumber : this.zoomInData.volumeMedian);
          this.zoomInData.trend.forEach(item => {
            item.volumeDMValue = (item.volume!=null ? item.volume * xnumber : item.volume);
            item.volumeDMValueRegression = (item.volumeRegression!=null ? item.volumeRegression * xnumber : item.volumeRegression);
          })
        }

        this.zoomInData.containmentPercentHide = true;
        this.zoomInData.avgTransfersHide = true;
        if(this.$refs.metricsChart) {
          this.$refs.metricsChart.chartRendered = false;
        }
        this.loading = false;
        this.hasData = (this.zoomInData.trend && this.zoomInData.trend.length > 0);
      }
    },

    refreshPage() {
      this.handleFilterChange();
    }
  },

  async created() {
    this.initDate = new Date()
    this.$router.currPageComponent = this;
    // listen events from other components
    this.$root.registerPageEvent(this.$route.name, (event) => {
      if(this[event.name]) this[event.name]();
    })
    this.handleFilterChange();
  },

  mounted() {
    this.$root.registerTooltips(this.$el);
  },

  beforeDestroy() {
    this.$root.unregisterTooltips(this.$el);
  }

});
</script>

<style lang="scss">
  .wy-interactions-metrics-page {
    .el-loading-mask {
      height: calc(100vh - 100px) !important;
    }
    .wy-page-title {
      margin-bottom: 40px;
      line-height: 0.7;
      height: 25px;
    }
    .wy-page-title-small {
      display: none;
      color: var(--site-font-secondary-color);
      font-size: 15px;
      font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
      font-weight: 400;
    }
    .el-loading-text {
      display: none;
    }

    min-width: 1130px;
    .stats-header {
      color: var(--site-font-secondary-color);
      font-size: 25px;
      font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
      font-weight: 600;
      .el-icon-info {
        position: relative;
        left: 5px;
        bottom: 10px;
        line-height: 0;
        background-color: #ACB8C6;
        color: #214586;
        font-size: 15px;
        cursor: pointer;
      }
    }
    .stats-summary-zoom-in-on {
      margin-top: 20px;
    }
  }

</style>